import { cn } from "@/lib/utils";

export function ArrowLeft2({ className }: { className?: string }) {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        d="M7.25 9.6665L2.41667 14.4998L7.25 19.3332"
        stroke="currentColor"
        strokeWidth="2.41667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.584 14.5H2.41732"
        stroke="currentColor"
        strokeWidth="2.41667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
